import { useState, useMemo } from "react";

const useSortableData = (data, config = {key: 'fio', direction: 'descending'}) => {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {

    const sortedDatas = [...data];
    if (sortConfig !== null) {
      sortedDatas.sort((a, b) => {   
        let itemA;     
        let itemB;     
        if(sortConfig.key === 'timeslot' || sortConfig.key === 'dateAdd' || sortConfig.key === 'dateCheck' || sortConfig.key === 'dateStart' || sortConfig.key === 'dateEnd' || sortConfig.key === 'date') {
          itemA = a[sortConfig.key].split(" ")[0].split(".").reverse().join("-") + " " + a[sortConfig.key].split(" ")[1]
          itemB = b[sortConfig.key].split(" ")[0].split(".").reverse().join("-") + " " +b[sortConfig.key].split(" ")[1]
        } else {
          itemA = a[sortConfig.key]
          itemB = b[sortConfig.key]
        }
        if (itemA < itemB) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (itemA > itemB) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedDatas;
  }, [data, sortConfig]);


  const requestSort = key => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key,direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableData;
